(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-of-countdown-section-final"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function initCountdown(el) {
      var releaseRaw = el.getAttribute('data-release');
      if (!releaseRaw) return;

      var releaseDate = new Date(releaseRaw);
      var daysEl = el.querySelector('[data-bo-days]');
      var hoursEl = el.querySelector('[data-bo-hours]');
      var minutesEl = el.querySelector('[data-bo-minutes]');
      var secondsEl = el.querySelector('[data-bo-seconds]');

      function tick() {
        var diff = releaseDate.getTime() - new Date().getTime();

        if (diff <= 0) {
          window.location.reload();
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    }

    function addToGoogle(name, dateStr) {
      var d = new Date(dateStr);
      var pad2 = function (n) { return String(n).padStart(2, '0'); };
      var stamp = d.getFullYear() + pad2(d.getMonth() + 1) + pad2(d.getDate()) + 'T' + pad2(d.getHours()) + pad2(d.getMinutes()) + '00';
      var url = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
        + '&text=' + encodeURIComponent('Best-of: ' + name + ' ist da')
        + '&dates=' + stamp + '/' + stamp
        + '&details=' + encodeURIComponent('Das neue EHLE. Best-of Unikat ist jetzt im Shop erhaeltlich.');
      window.open(url, '_blank');
    }

    function downloadIcs(name, dateStr) {
      var d = new Date(dateStr);
      var pad2 = function (n) { return String(n).padStart(2, '0'); };
      var stamp = d.getFullYear() + pad2(d.getMonth() + 1) + pad2(d.getDate()) + 'T' + pad2(d.getHours()) + pad2(d.getMinutes()) + '00';
      var ics = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nBEGIN:VEVENT\r\n'
        + 'SUMMARY:Best-of: ' + name + ' ist da\r\n'
        + 'DTSTART:' + stamp + '\r\n'
        + 'DESCRIPTION:Das neue EHLE. Best-of Unikat ist jetzt im Shop erhaeltlich.\r\n'
        + 'END:VEVENT\r\nEND:VCALENDAR';

      var blob = new Blob([ics], { type: 'text/calendar' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'ehle-best-of-' + name.toLowerCase() + '.ics';
      link.click();
    }

    document.querySelectorAll('[data-bo-countdown]').forEach(initCountdown);

    document.querySelectorAll('[data-bo-calendar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dropdown = btn.nextElementSibling;
        document.querySelectorAll('[data-bo-calendar-dropdown]').forEach(function (dd) {
          if (dd !== dropdown) dd.classList.remove('bo-dropdown--open');
        });
        dropdown.classList.toggle('bo-dropdown--open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.bo-calendar-wrap')) {
        document.querySelectorAll('[data-bo-calendar-dropdown]').forEach(function (dd) {
          dd.classList.remove('bo-dropdown--open');
        });
      }
    });

    document.querySelectorAll('[data-bo-google]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        addToGoogle(a.getAttribute('data-name'), a.getAttribute('data-date'));
      });
    });

    document.querySelectorAll('[data-bo-ics]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        downloadIcs(a.getAttribute('data-name'), a.getAttribute('data-date'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsere-bestseller"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[id^="Bestseller-"]').forEach(function (section) {
  var tabs = section.querySelectorAll('.bestseller-tab');
  var panels = section.querySelectorAll('.bestseller-panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.classList.remove('active'); });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var index = tab.getAttribute('data-tab-index');
      var panel = section.querySelector('.bestseller-panel[data-panel-index="' + index + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  section.querySelectorAll('.bestseller-panel').forEach(function (panel) {
    var carousel = panel.querySelector('.bestseller-carousel');
    var prev = panel.querySelector('.bestseller-nav.prev');
    var next = panel.querySelector('.bestseller-nav.next');
    var dotsWrap = panel.querySelector('.bestseller-dots');
    var cardWidth = 340;

    if (prev) prev.addEventListener('click', function () { carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { carousel.scrollBy({ left: cardWidth, behavior: 'smooth' }); });

    var cardCount = carousel.querySelectorAll('.bestseller-card').length;
    if (dotsWrap && cardCount > 1) {
      for (var i = 0; i < Math.min(cardCount, 5); i++) {
        var dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dotsWrap.appendChild(dot);
      }
      carousel.addEventListener('scroll', function () {
        var ratio = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth || 1);
        var dots = dotsWrap.querySelectorAll('.dot');
        var idx = Math.min(dots.length - 1, Math.round(ratio * (dots.length - 1)));
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
